import { Button, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";

let userToken = localStorage.getItem("userToken");

export default function EditRedirect({
  itemToEdit,
  setItemToEdit,
  endpoint,
  refresh,
  setRefresh,
}) {
  const [input, setInput] = useState({});

  const fileInputRef = useRef();

  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setItemToEdit({});
      setInput(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (Object.keys(itemToEdit).length > 0) {
        try {
          const response = await fetch(
            `${API}/${endpoint}/${itemToEdit.id}?populate=*`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userToken}`,
              },
              method: "GET",
            }
          );
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const res = await response.json();
          setInput(res.data.attributes);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }

    fetchData();
  }, [itemToEdit]);

  const handleInputChange = (field, value) => {
    setInput({
      ...input,
      [field]: value,
    });
  };

  const saveChanges = () => {
    fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: input,
      }),
    })
      .then(async (res) => {
        if (res.ok) {
          setRefresh(!refresh);
          setItemToEdit({});
          setInput(null);

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        } else {
          const errorData = await res.json();
          console.error("Error updating entry:", errorData);
          toast("Error updating entry", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        toast("Error updating entry", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      });
  };

  return (
    <div
      style={{
        backgroundColor: "#00000020",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 99999999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex"
    >
      <div
        ref={ref}
        style={{
          width: 700,
          height: "auto",
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: "4rem 2rem",
        }}
      >
        {input && (
          <div
            className="fadeInFast"
            style={{
              marginTop: 10,
              marginBottom: 20,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              transition: "0.3s",
            }}
          >
            <TextField
              label="Source URL"
              sx={{ width: "90%" }}
              value={input.source}
              onChange={(e) => handleInputChange("source", e.target.value)}
            />
            <TextField
              label="Destination"
              sx={{ width: "90%", mt: 2, mb: 2 }}
            
              value={input.destination}
              onChange={(e) => handleInputChange("destination", e.target.value)}
            />
            <div className="mt-4 gap-3 flex">
              <Button
                variant="contained"
                disableElevation
                style={{
                  background: input.type == 301 ? null : "#99cfe0",
                }}
                onClick={() => setInput({ ...input, type: 301 })}
              >
                301 Permanent Move
              </Button>
              <Button
                variant="contained"
                disableElevation
                style={{ background: input.type == 302 ? null : "#99cfe0" }}
                onClick={() => setInput({ ...input, type: 302 })}
              >
                302 Temporary Move
              </Button>
              <Button
                variant="contained"
                disableElevation
                style={{ background: input.type == 307 ? null : "#99cfe0" }}
                onClick={() => setInput({ ...input, type: 307 })}
              >
                307 Temporary Redirect
              </Button>
            </div>
          </div>
        )}
        <div
          className="submitBTN"
          style={{ margin: "0 auto", marginTop: 0 }}
          onClick={saveChanges}
        >
          Save Changes
        </div>
      </div>
    </div>
  );
}
